@if(loader){
<app-loader></app-loader>
}
<p-card header="">

    <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">
            <p-button label="New" (onClick)="create()" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                pTooltip="Create Request for Quote"></p-button>

            <div class="flex align-items-center ml-3">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                        class="p-inputtext-sm" (keyup.enter)="searchRfq()"
                        style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                </span>
                <p-button icon="pi pi-search" (onClick)="searchRfq()" [raised]="true" [size]="'small'" severity="info"
                    class="ml-2" [ngStyle]="{ height: '35px' }"></p-button>
            </div>

            <p-button (onClick)="edit()" *ngIf="selectedRfq && selectedRfq.length == 1" label="Edit"
                class="p-button-outlined ml-2" icon="pi pi-user-edit" severity="secondary" size="small"></p-button>
            <p-button (onClick)="deleteQuote()" *ngIf="selectedRfq && selectedRfq.length > 0" label="Delete"
                class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger" size="small"></p-button>
        </div>
        <h2 class="page-title-center">RFQ List</h2>

        <div class="toolbar-section right">
            <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                severity="info"></p-button>
        </div>

    </div>


    <p-table #dt1 [value]="rfqList" [scrollable]="true" scrollHeight="613px"
        styleClass="p-datatable-striped p-datatable-sm" responsiveLayout="scroll" class="w-full m-5" [paginator]="true"
        [rows]="10" [rowsPerPageOptions]="[10, 15, 20]" [(selection)]="selectedRfq"
        [globalFilterFields]="['salesOrderNumber', 'customer.customerName']" (onPage)="loadRfqList($event)"
        [rowHover]="true">

        <ng-template pTemplate="header">
            <tr>
                <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                <th>RFQ No</th>
                <th>RFQ Name</th>
                <th>RFQ Date</th>
                <th>{{unitLabel}} Name</th>
                <th>Created By</th>
                <th>Print</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rfq>
            <tr>
                <td><p-tableCheckbox [value]="rfq"></p-tableCheckbox></td>
                <td class="text-blue-500 underline" style="cursor: pointer;" (click)="edit(rfq.rfqID)">
                    {{ rfq.rfqCode }}
                </td>
                <td>{{ rfq.rfqName }}</td>
                <td>{{ rfq.rfqDate | date: 'dd/MM/yyyy'}}</td>
                <td>{{ rfq.warehouse.warehouseName }}</td>
                <td>{{ rfq.createdBy }}</td>
                <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                        (click)="showReport(rfq)"></span></td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center text-gray-500">No results found.</td>
            </tr>
        </ng-template>

    </p-table>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>